import usePageTitleSync from 'Pods/ThreeDStudio/Hooks/usePageTitleSync'

// Rendered under ThreeDStudioPageContext.Provider: the hook translates through that context,
// which ThreeDStudioContent itself cannot read because it is the component providing it. Called
// from ThreeDStudioContent it saw the default `en` locale and wrote English meta on /pt/.
function PageTitleSync() {
  usePageTitleSync()
  return null
}

export default PageTitleSync
